import { render } from "./NoPrefferdInvitation.vue?vue&type=template&id=52896e70"
import script from "./NoPrefferdInvitation.vue?vue&type=script&lang=js"
export * from "./NoPrefferdInvitation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__